module.exports = __webpack_public_path__ + "537b0021a02e503036b3fdc52bf60ba8.svg";